import { Surface } from '@faire/web-api--source/com/faire/logging/Surface';
import { AppPlatform } from '@faire/web-api--source/com/faire/user_event_types/AppPlatform';
import { IClientProductImpressionDwellEvent } from '@faire/web-api--source/com/faire/user_event_types/IClientProductImpressionDwellEvent';
import { IClientProductImpressionEnterEvent } from '@faire/web-api--source/com/faire/user_event_types/IClientProductImpressionEnterEvent';
import { IClientProductImpressionLeaveEvent } from '@faire/web-api--source/com/faire/user_event_types/IClientProductImpressionLeaveEvent';
import { IProductClickEvent } from '@faire/web-api--source/com/faire/user_event_types/IProductClickEvent';
import { IProductQuickAddClickEvent } from '@faire/web-api--source/com/faire/user_event_types/IProductQuickAddClickEvent';

export namespace ITypedClientEventRequest {
  /**
   * Return an instance of ITypedClientEventRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<ITypedClientEventRequest>
  ): ITypedClientEventRequest =>
    ({
      ...(partial ?? {}),
    }) as ITypedClientEventRequest;
}

export interface ITypedClientEventRequest {
  /**
   * The associated reference to the event schema of the event to be published.
   */
  event_key: string | undefined;
  /**
   * @protobufOption (faire.protobuf.validation) = TIMESTAMP_MILLIS
   */
  client_created_at: number | undefined;
  /**
   * Unique identifier for the event. Used for deduplication when forwarding the event to a 3rd-party system from
   * both the client and the server (for redundancy, e.g. Facebook Pixel)
   */
  event_id: string | undefined;
  /**
   * If we are recording a trace event, pass in sourceEventHash to indicate which source event it's following
   */
  source_event_hash: string | undefined;
  /**
   * The duration from the start of the parent event to the trace event being recorded with this request.
   * This should be measured in milliseconds.
   */
  timing: number | undefined;
  /**
   * The client platform (e.g. web, iOS, Android) the event was recorded on.
   */
  app_platform: keyof typeof AppPlatform | undefined;
  /**
   * The client's app version that the event was recorded on.
   */
  app_version: string | undefined;
  /**
   * The client's platform version that the event was recorded on. Only populated on mobile apps - blank for web.
   */
  platform_version: string | undefined;
  /**
   * The surface the event was recorded on. E.g. homepage, brand page, search page, etc.
   */
  surface: keyof typeof Surface | undefined;
  client_product_impression_enter_event:
    | IClientProductImpressionEnterEvent
    | undefined;
  client_product_impression_dwell_event:
    | IClientProductImpressionDwellEvent
    | undefined;
  client_product_impression_leave_event:
    | IClientProductImpressionLeaveEvent
    | undefined;
  product_click_event: IProductClickEvent | undefined;
  product_quick_add_click_event: IProductQuickAddClickEvent | undefined;
}
